export default __webpack_public_path__ + "static/media/logot2k3i.3d3fe664.png";